import { push } from 'react-router-redux';

const INITIAL_STATE = {
  displayFilter: false,
  filterKey: undefined
};

const types = {
  SET_DISPLAY_FILTER: 'orb/filterRecords/SET_DISPLAY_FILTER'
};

export default function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case types.SET_DISPLAY_FILTER:
      return Object.assign({}, state, {
        displayFilter: action.displayFilter,
        filterKey: action.filterKey
      });
    default:
      return state;
  }
}
reducer.types = types;
reducer.initialState = INITIAL_STATE;

export function setDisplayFilter(displayFilter, filterKey = undefined) {
  return {
    type: types.SET_DISPLAY_FILTER,
    displayFilter,
    filterKey
  };
}

export function filterNavigate(url) {
  return (dispatch) => {
    // Navigate to new url with filters, taking only valid filter params
    dispatch(push(url));
  };
}



// WEBPACK FOOTER //
// ./src/filter/reducer.js